<div *transloco="let translate">
    <div class="dropZone fileBrowseContainer" [hidden]="appendedFileName?.length > 0" (click)="!isDisabled && openFileSelection()">
        <span [textContent]="dragDropText"></span>
        <material-button class="mat-elevation-z1 fileBrowseContainer buttonClass" [buttonType]="'raised'" [classList]="['!w-auto']" [color]="'primary'" [text]="data.title"></material-button>
    </div>
    <div class="dropZone fileBrowseContainer fileNameContainer" [hidden]="!appendedFileName" [title]="appendedFileName" (click)="!isDisabled && openFileSelection()">
        <span [textContent]="appendedFileName"></span>
    </div>
    <div class="fileDropZoneContainer" fileDnD (droppedFiles)="onFilesDropEvent($event)" (fileHovered)="fileHovered = $event">
        <div class="fileDropZoneText dropText" [class.fileHovered]="fileHovered" *transloco="let translate">
            <span [textContent]="translate('Drop files here')"></span>
        </div>
    </div>
</div>

<input #fileInput [name]="data.name" hidden class="fileUploadbox" stop-propagation (click)="fileInput.value = null" type="file" [id]="id" [(ngModel)]="files" (change)="onInputChange($event)" [accept]="acceptFormats || undefined" />
